// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sharedCarouselStyles } from "@eisinc/App/SharedStyles/ProductCarouselStyles";
import { productCarouselStyles } from "@eisinc/Overrides/Widgets/Common/ProductCarousel";
import { css } from "styled-components";

productCarouselStyles.miniCardStyles = {
    ...sharedCarouselStyles.miniCardStyles,
};

productCarouselStyles.carouselProductCondensedStyles = {
    ...sharedCarouselStyles.carouselProductCondensedStyles,
};

productCarouselStyles.carouselProductStyles = {
    ...sharedCarouselStyles.carouselProductStyles,
};

productCarouselStyles.swiperStyles = {
    ...sharedCarouselStyles.swiperStyles,
};

productCarouselStyles.condensedSwiperStyles = {
    ...sharedCarouselStyles.condensedSwiperStyles,
};

productCarouselStyles.titleText = {
    variant: "h2",
    css: css`
        ${({ alignment }: any) =>
            css`
                text-align: ${alignment};
            `}

        ${({ italicizeTitle }: any) =>
            italicizeTitle &&
            css`
                font-style: italic;
            `}                  
    `,
};
